import * as React from "react";
import { Hostovani } from "common/api/Evidence/Clenove/HostovaniDlouhodoba";
import Stav from "./Stav";
import ZakladniUdaje from "./ZakladniUdaje";
import SpravniPoplatek from "./SpravniPoplatek";
import PotvrzeniZamitnuti from "./PotvrzeniZamitnuti";
import Stornovani from "./Stornovani";
import Ukonceni from "./Ukonceni";

interface ViewProps {
    clenId: number;
    klubId?: number;
    hostovani: Hostovani;
    setHostovani: (hostovani: Hostovani) => void;
}

class View extends React.PureComponent<ViewProps> {

    render() {
        const { hostovani, setHostovani, clenId, klubId } = this.props;

        const dtProps = {
            hostovani: hostovani,
            setHostovani: setHostovani,
            je_to_clen: (hostovani && hostovani.clen_id === clenId),
            je_to_dom_klub: (hostovani && hostovani.dom_klub_id == klubId),
            je_to_host_klub: (hostovani && hostovani.host_klub_id && hostovani.host_klub_id == klubId),
            hostovani_z_divize: (hostovani && !hostovani.dom_klub_id)
        }



        return <div>
            <Stav stav={hostovani.stav} dat_potvrz_ic={hostovani.dat_potvrz_ic} dat_potvrz_kc={hostovani.dat_potvrz_kc} zamitnuto_ic={hostovani.zamitnuto_ic} zamitnuto_kc={hostovani.zamitnuto_kc} />
            <PotvrzeniZamitnuti {...dtProps} />
            <Stornovani {...dtProps} />
            <Ukonceni {...dtProps} />
            <ZakladniUdaje {...dtProps} />
            <SpravniPoplatek {...dtProps} />
        </div>
    }
}

export default View;